import React from 'react'
import { Grid, Typography } from '@mui/material'
import { PROVIDER_FIELDS } from '_/views/provider/constants'

import Chip from '_components/chip'

import useStyles from './styles'
import CategoryIndicator from '_/components/category-indicator'
import { phoneNumberMask } from '_/utils/helpers'

export const ProvidersTableColumns = () => {
  const styles = useStyles()
  return [
    { field: PROVIDER_FIELDS.NAME, headerName: 'Nome', minWidth: 300 },
    { field: PROVIDER_FIELDS.PERSON_RESPONSIBLE_NAME, headerName: 'Responsável', minWidth: 300 },
    {
      field: PROVIDER_FIELDS.PHONE,
      headerName: 'Telefone',
      width: 150,
      renderCell: params => (
        <Typography>{phoneNumberMask(params?.value).replace('+55', '')}</Typography>
      ),
    },
    {
      field: PROVIDER_FIELDS.MAIN_SERVICE_NAMES,
      headerName: 'Categoria',
      placeholder: 'da categoria',
      width: 300,
      renderCell: params => {
        const categories = params?.value?.split(',')
        if (!params?.value) {
          return params?.value
        }
        if (categories?.length > 1)
          return (
            <Grid container alignItems="center">
              <Chip label={categories[0]} className={styles.categoryChip} />
              <CategoryIndicator
                tooltipText={categories.join(', ').replace(/, ((?:.(?!, ))+)$/, ' e $1')}
                label={`+${categories.length - 1}`}
              />
            </Grid>
          )
        return <Chip label={categories} />
      },
    },
  ]
}
